const ITEMS = [
  { id: 'heute', label: 'Heute', icon: '◆' },
  { id: 'board', label: 'Board', icon: '▦' },
  { id: 'daten', label: 'Daten', icon: '⛁' },
  { id: 'mehr',  label: 'Mehr',  icon: '•' },
]

export default function QuickDock({ tab, setTab, onCoach, onDb }) {
  return (
    <aside className="hidden md:flex sticky top-20 self-start flex-col items-center gap-2 py-3 border border-white/10 rounded-md">
      {ITEMS.map((t) => (
        <button key={t.id} onClick={() => setTab(t.id)}
                title={t.label}
                className={`tap w-12 h-12 grid place-items-center rounded ${
                  tab === t.id ? 'bg-[var(--accent)] text-black' : 'hover:bg-white/5 text-white/70'
                }`}>
          <span className="text-lg">{t.icon}</span>
        </button>
      ))}
      {(onCoach || onDb) && <div className="h-px w-8 bg-white/10 my-1" />}
      {onCoach && (
        <button onClick={onCoach} title="Coach"
                className="tap w-12 h-12 grid place-items-center rounded border border-[var(--accent)]/40 text-[var(--accent)] animate-pulse-glow">
          ⚔
        </button>
      )}
      {onDb && (
        <button onClick={onDb} title="DB"
                className="tap w-12 h-12 grid place-items-center rounded hover:bg-white/5 text-white/70">
          ⛁
        </button>
      )}
    </aside>
  )
}
